import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Most frequent element in an Array",
  url: "most-frequent-element-array",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {Any[]} arr
* @return {Any}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function mostFrequent(arr) {
  // your code goes here        
};
`,
};

export default info;
